export enum PurchaseLimitError {
  PurchaseLimitExceeded = 'PurchaseLimitExceeded',
  PurchaseLimitPartial = 'PurchaseLimitPartial',
  PurchaseLimitBackorderOnly = 'PurchaseLimitBackorderOnly',
  PurchaseLimitBackorderPartial = 'PurchaseLimitBackorderPartial',
}
